export const classes = {
  wrapper: 'flex w-full items-center gap-3',
  name: 'grow min-w-0 text-taupe-3 dark:text-mauve-1 font-semibold text-[13px] leading-tight hover:underline cursor-pointer outline-none',
  resolved: 'text-[#8a909c] line-through',
};
